module.exports = __webpack_public_path__ + "img/TikTok.2bd52796.svg";